import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import Dropzone from 'react-dropzone';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { browserHistory } from '../../helpers/history';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactQuill from 'react-quill';
import * as Service from '../../services/feedbackarticle.service';
class FeedbackArticleRegistration extends Component {

    constructor(props) {
        super(props);

        const { userSession } = this.props;
        this.globalAdm = false;
        this.isClient = true;
        if (!(userSession?.user?.userrole != null)) {
            Api.logoff();
        }
        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false;
            }
            if (item.role.roletype == 0) {
                this.globalAdm = true;
            }
        }
        );


        this.initialState = {
            createdUser: userSession.user.id,
            createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
            name: '',
            description: '',

        };
        this.state = {
            item: this.initialState,
            files: [],
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.changeValues = this.changeValues.bind(this);
    }

    componentDidMount() {
    };

    handleChangeEditor(value, name) {
        this.setState(prevState => ({
            item: {
                ...prevState.item,
                [name]: value || ""
            }
        }));
      }

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        if (name === 'name') {
            if (value.length <= 255) {
                this.setState(prevState => ({
                    item: {
                        ...prevState.item,
                        [name]: value
                    }
                }));
            }
        } else if (name === 'description') {
            if (value.length <= 500) { // Limite máximo de 500 caracteres para 'description'.
                this.setState(prevState => ({
                    item: {
                        ...prevState.item,
                        [name]: value
                    }
                }));
            }
        } else {
            this.setState(prevState => ({
                item: {
                    ...prevState.item,
                    [name]: value
                }
            }));
        }
    }


    handleSubmit = async e => {
        e.preventDefault();

        this.setState({ loading: true });

        const { name, description } = this.state.item; // Desestrutura os campos para facilitar o uso.

        // Validação do campo 'name'.
        if (name.length > 255) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "name" }) + " " + intl.formatMessage({ id: "limit255" })
            });
            return; // Interrompe a execução caso o 'name' seja inválido.
        }

        // Validação do campo 'description'.
        if (description && description.length > 500) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "description" }) + " " + intl.formatMessage({ id: "limit500" })
            });
            return; // Interrompe a execução caso o 'description' seja inválido.
        }

        let data = new FormData();

        // Adiciona os dados ao FormData, formatando as datas corretamente.
        for (let key in this.state.item) {
            if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
                data.append(key, moment(this.state.item[key]).format('YYYY/MM/DD HH:mm:ss'));
            } else {
                data.append(key, this.state.item[key]);
            }
        }


        // Realiza a requisição à API.
        try {
            const result = await Api.post('/feedback-article', data);

            if (result.data.success) {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'success',
                    notificationMessage: intl.formatMessage({ id: "add.success" }),
                    item: this.initialState,
                    files: []
                });
            } else {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result.data.errors
                        ? result.data.errors[0]
                        : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: err.response?.data?.errors
                    ? err.response.data.errors[0]
                    : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(err);
        }
    };


    closeNotification() {
        this.setState({ openNotification: false });
    }

    changeValues(stateName, value, text = '') {
        this.setState({ loading: true });

        this.setState(prevState => ({
            item: {
                ...prevState.item,
                [stateName]: value
            }
        }));
        this.setState({ loading: false });

    };

    removeItem(file) {
        let array = [...this.state.files];
        let index = array.indexOf(file)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ files: array });
        }
    }
    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const { item } = this.state;
        const intl = this.props.intl;

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth='md'>
                        <CssBaseline />
                        <div className={classes.paper} style={{ marginTop: 0 }}>
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={4}>
                                    <Button variant='outlined' color='primary' onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
                                </Grid>
                                <Grid item xs={12} sm={8} />
                            </Grid>
                            <Avatar className={classes.avatar}>
                                <QueuePlayNext />
                            </Avatar>
                            <Typography component='h1' variant='h5'>
                                {<FormattedMessage id="add.item" />}
                            </Typography>
                            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <TextField fullWidth label={intl.formatMessage({ id: "name" })} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={item.name} required />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <Typography>
                                            <FormattedMessage id="description" />
                                        </Typography>
                                        <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                                            <ReactQuill
                                                name="description"
                                                value={item.description}
                                                style={{ height: "100%" }}
                                                modules={this.reactQuillModules}
                                                formats={this.reactQuillFormats}
                                                fullWidth
                                                variant="outlined"
                                                id="description"
                                                onChange={(value) => this.handleChangeEditor(value, "description")} required
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Grid container justify="flex-end" spacing={2} style={{ justifyContent: 'flex-end' }}>
                                            <Grid item xs={12} sm={4}    >
                                                <Button
                                                    type='submit'
                                                    fullWidth
                                                    variant='contained'
                                                    color='primary'
                                                    className={classes.submit}
                                                >
                                                    {<FormattedMessage id="save" />}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
            </div>
        );
    }
}
FeedbackArticleRegistration.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});
export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(FeedbackArticleRegistration)));
